export default __webpack_public_path__ + "static/silkserif-extralight-3312b0b0c3f51a055973250ffdbf40dd.woff";